import {PickerResult} from '../../../../../shared/components/filePicker/model';

const mbToBytes = (mb: number) => mb * 1024 * 1024;

export const removeDuplicates = (current: PickerResult[], newData: PickerResult[]): PickerResult[] => {
  if (current.length === 0) {
    return newData;
  }

  return newData.filter((item) => current.every((curItem) => curItem.file.name !== item.file.name));
};

export const checkFilesMaxSize = (files: PickerResult[], maxSizeMb: number): [PickerResult[], PickerResult[]] => {
  let filesSize = 0;
  const maxSize = mbToBytes(maxSizeMb);
  return files.reduce<[PickerResult[], PickerResult[]]>(
    (acc, curFile) => {
      const [accepted, rejected] = acc;
      filesSize += curFile.file.size;
      if (filesSize > maxSize) {
        rejected.push(curFile);
      } else {
        accepted.push(curFile);
      }

      return acc;
    },
    [[], []],
  );
};

export const checkFilesFormats = (files: PickerResult[], formats: string[]): [PickerResult[], PickerResult[]] => {
  return files.reduce<[PickerResult[], PickerResult[]]>(
    (acc, curFile) => {
      const [accepted, rejected] = acc;
      const fileFormat = curFile.file.type.split('/')[1] ?? '';
      // We extract fileNameExtension separately to prevent uploading of `jfif` files because of their type being jpeg.
      // https://en.wikipedia.org/wiki/JPEG_File_Interchange_Format#:~:text=Because%20JFIF%20is%20not%20the%20original%20JPG%20standard%2C%20one%20might%20expect%20another%20MIME%20type.%20However%2C%20it%20is%20still%20registered%20as%20%22image/jpeg%22%20(indicating%20its%20primary%20data%20format%20rather%20than%20the%20amended%20information).
      const fileNameExtension = curFile.file.name.substring(curFile.file.name.lastIndexOf('.') + 1).toLowerCase();
      if (formats.includes(fileFormat) && formats.includes(fileNameExtension)) {
        accepted.push(curFile);
      } else {
        rejected.push(curFile);
      }

      return acc;
    },
    [[], []],
  );
};
